module.exports = __webpack_public_path__ + "src/assets/img/door_left_back_color.4c32b0b1.svg";